"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var React = _interopRequireWildcard(require("react"));
var _gemUrlFormatUtils = require("../../common/utils/domain/gemUrlFormatUtils");
require("../../common/style.scss");
var _reportUtil = require("../../utils/reportUtil");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Created By Gems CLI
 * Issues and merge requests are welcomed：https://git.woa.com/hulk/gems
 *
 * API 参考：
 * http://gems.woa.com/?path=/docs/%E5%BC%80%E5%8F%91-%E4%B8%9A%E5%8A%A1%E7%B4%A0%E6%9D%90%E5%BA%93-%E7%BC%96%E5%86%99%E7%BB%84%E4%BB%B6--page
 */

const _require = require('@tencent/cms-design-component'),
  FunctionalComparison = _require.FunctionalComparison;
const formatFunctionalComparison = (properties, options = {}) => {
  const flexTitle = properties.flexTitle,
    desc = properties.desc,
    _properties$configura = properties.configuration,
    configuration = _properties$configura === void 0 ? {} : _properties$configura,
    _properties$pcBigBg = properties.pcBigBg,
    pcBigBg = _properties$pcBigBg === void 0 ? '' : _properties$pcBigBg,
    _properties$classifyO = properties.classifyOneIcon,
    classifyOneIcon = _properties$classifyO === void 0 ? '' : _properties$classifyO,
    _properties$classifyO2 = properties.classifyOneBg,
    classifyOneBg = _properties$classifyO2 === void 0 ? '' : _properties$classifyO2,
    _properties$classifyT = properties.classifyTwoIcon,
    classifyTwoIcon = _properties$classifyT === void 0 ? '' : _properties$classifyT,
    _properties$classifyT2 = properties.classifyTwoBg,
    classifyTwoBg = _properties$classifyT2 === void 0 ? '' : _properties$classifyT2;
  const _getFormatUrlMethods = (0, _gemUrlFormatUtils.getFormatUrlMethods)({
      domains: options === null || options === void 0 ? void 0 : options.domains
    }),
    formatUrlInText = _getFormatUrlMethods.formatUrlInText;
  const prodLTitlePc = configuration.prodLTitlePc,
    prodCTitlePc = configuration.prodCTitlePc,
    _configuration$prodCo = configuration.prodCompareType,
    prodCompareType = _configuration$prodCo === void 0 ? [] : _configuration$prodCo,
    _configuration$prod1D = configuration.prod1Desc,
    prod1Desc = _configuration$prod1D === void 0 ? [] : _configuration$prod1D,
    _configuration$prod2D = configuration.prod2Desc,
    prod2Desc = _configuration$prod2D === void 0 ? [] : _configuration$prod2D;
  const resultProdCompareType = prodCompareType.map(item => {
    return item.name || '';
  });
  const resultProd1Desc = prod1Desc.map(item => {
    return item.name || '';
  });
  const resultProd2Desc = prod2Desc.map(item => {
    return item.name || '';
  });
  return {
    flexTitle,
    desc: formatUrlInText(desc),
    configuration: {
      prodLTitlePc,
      prodCTitlePc,
      prodCompareType: resultProdCompareType,
      prod1Desc: resultProd1Desc,
      prod2Desc: resultProd2Desc
    },
    pcBigBg,
    classifyOneIcon,
    classifyOneBg,
    classifyTwoIcon,
    classifyTwoBg
  };
};
function _default({
  componentKey,
  // {number} 用于标识每一个组件实例的全局唯一且持久化的 key
  data,
  // {object} “数据”表单内容
  style,
  // {object} “样式”表单内容
  commonStyle,
  // {object} “组件自定义样式”表单内容
  global,
  // {object} 页面容器自定义的全局配置项
  meta,
  // {object} 页面元数据
  componentsMap,
  // {Map<number, HTMLElement>} 所有组件 DOM 节点的 Map，key 为组件的 key（number）
  getComponentByKey,
  // {(key: number) => HTMLElement | undefined} 通过组件 key 获取组件 DOM 节点的 API
  store,
  // {object} 组件状态
  on,
  // {(event: string, callback: Function) => void} 事件触发调用
  emit,
  // {(event: string) => void | Promise<void>} 监听事件
  domains: domainInfos
}) {
  const domains = (0, _gemUrlFormatUtils.useDomainGems)({
    domainInfos
  });
  if (Object.keys(data).length > 1) {
    const _formatFunctionalComp = formatFunctionalComparison(data, {
        domains
      }),
      flexTitle = _formatFunctionalComp.flexTitle,
      desc = _formatFunctionalComp.desc,
      configuration = _formatFunctionalComp.configuration,
      pcBigBg = _formatFunctionalComp.pcBigBg,
      classifyOneIcon = _formatFunctionalComp.classifyOneIcon,
      classifyOneBg = _formatFunctionalComp.classifyOneBg,
      classifyTwoIcon = _formatFunctionalComp.classifyTwoIcon,
      classifyTwoBg = _formatFunctionalComp.classifyTwoBg;
    return /*#__PURE__*/React.createElement("div", Object.assign({
      id: flexTitle
    }, (0, _reportUtil.reportShow)(['show_functionalComparison', componentKey, flexTitle])), /*#__PURE__*/React.createElement(FunctionalComparison, {
      flexTitle: flexTitle,
      desc: desc,
      configuration: configuration,
      pcBigBg: pcBigBg,
      classifyOneIcon: classifyOneIcon,
      classifyOneBg: classifyOneBg,
      classifyTwoIcon: classifyTwoIcon,
      classifyTwoBg: classifyTwoBg
    }));
  } else {
    return /*#__PURE__*/React.createElement("div", null);
  }
}